import { Artifact, ArtifactSearchResult, CreateArtifactData, UpdateArtifactData } from './artifact';

export interface StorageService {
  createArtifact(data: CreateArtifactData): Promise<Artifact>;
  getArtifact(id: string): Promise<Artifact | null>;
  getAllArtifacts(): Promise<Artifact[]>;
  updateArtifact(id: string, updates: UpdateArtifactData): Promise<Artifact>;
  deleteArtifact(id: string): Promise<boolean>;

  importArtifacts(artifacts: Artifact[]): Promise<void>;
  exportArtifacts(): Promise<Artifact[]>;

  searchArtifacts(query: string): Promise<ArtifactSearchResult[]>;

  clearAll(): Promise<void>;
  getStorageInfo(): Promise<StorageInfo>;
}

export enum StorageErrorCode {
  QUOTA_EXCEEDED = 'QUOTA_EXCEEDED',
  NOT_FOUND = 'NOT_FOUND',
  INVALID_DATA = 'INVALID_DATA',
  STORAGE_UNAVAILABLE = 'STORAGE_UNAVAILABLE',
  NETWORK_ERROR = 'NETWORK_ERROR',
}

export class StorageError extends Error {
  details?: Record<string, unknown>;

  constructor(public code: StorageErrorCode, message?: string, details?: Record<string, unknown>) {
    super(message);
    this.name = 'StorageError';
    this.details = details;
  }
}

export interface StorageInfo {
  totalArtifacts: number;
  totalSize: number;
  storageQuota: number;
  storageUsed: number;
  availableSpace: number;
}

export interface StorageConfiguration {
  maxArtifactSize: number;
  maxTotalSize: number;
  enableCompression: boolean;
  autoCleanup: boolean;
} 